module.exports = __webpack_public_path__ + "png/3.png?496e3bf6883a8a356c5452f93856654e";